import { supabase } from '../supabase/supabase';

export { supabase };

// Database helper functions
export const dbHelpers = {
  // Get user profile
  async getUserProfile(userId) {
    if (!userId) throw new Error('User ID is required')
    const { data, error } = await supabase
      .from('profiles')
      .select('*')
      .eq('user_id', userId)
      .single()
    
    if (error) throw error
    return data
  },

  // Get user trades
  async getUserTrades(userId, limit = 50) {
    if (!userId) return []
    const { data, error } = await supabase
      .from('trades')
      .select('*')
      .eq('user_id', userId)
      .order('entry_time', { ascending: false })
      .limit(limit)
    
    if (error) throw error
    return data || []
  },

  // Add new trade
  async addTrade(tradeData) {
    const { data, error } = await supabase
      .from('trades')
      .insert([tradeData])
      .select()
    
    if (error) throw error
    if (!data || data.length === 0) throw new Error('Failed to create trade')
    return data[0]
  },

  // Update trade
  async updateTrade(tradeId, updates) {
    // Remove metadata fields that shouldn't be updated directly
    const { id, user_id, created_at, updated_at, ...cleanUpdates } = updates;

    const { data, error } = await supabase
      .from('trades')
      .update(cleanUpdates)
      .eq('id', tradeId)
      .select()
    
    if (error) throw error
    if (!data || data.length === 0) throw new Error('Trade not found')
    return data[0]
  },

  // Get trading statistics
  async getTradingStats(userId, dateFrom, dateTo) {
    if (!userId) return []
    const { data, error } = await supabase
      .from('trades')
      .select('*')
      .eq('user_id', userId)
      .gte('entry_time', dateFrom)
      .lte('entry_time', dateTo)
    
    if (error) throw error
    return data || []
  }
}